import { render, staticRenderFns } from "./ProjectCommentsPlaceholder.vue?vue&type=template&id=5064b45f&scoped=true&lang=html&"
var script = {}
import style0 from "./ProjectCommentsPlaceholder.vue?vue&type=style&index=0&id=5064b45f&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064b45f",
  null
  
)

export default component.exports